/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { LocationRestService } from '@gh/builder-shared-data';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { Location } from './location.model';

export interface LocationDetailsDialogConfig {
  modelId: ID;
}

@Injectable()
export class LocationBusinessService implements InitViewService, InitDialogViewService<LocationDetailsDialogConfig> {
  constructor(private locationRest: LocationRestService, private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('locations'),
    };
  }

  initDialogView(route: DialogRouteSnapshot<LocationDetailsDialogConfig>): Observable<any> {
    return this.locationRest.get(route.input.modelId);
  }

  create(location: Location): Observable<Location> {
    return this.locationRest.create(location);
  }

  update(location: Location): Observable<Location> {
    return this.locationRest.update(location);
  }

  remove(location: Location): Observable<Location> {
    return this.locationRest.remove(location);
  }

  get(id: ID): Observable<Location> {
    return this.locationRest.get(id);
  }

  findAllAsDataSource(): SlicedDataSource<Location> {
    return this.locationRest.findAllAsDataSource();
  }
}
